import React, { Component } from 'react';
import { runInAction } from "mobx";
import { inject, observer } from "mobx-react";
import i18n from "i18next";
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import validate from '../../utilities/validation-rules';

import RowText from '../form-rows/row-text';

import Checkbox from '../../elements/form-input-checkbox';
import Select from '../../elements/form-input-select';

const FormProfile = inject("stores") (
    observer (
        class FormProfile extends Component {

            constructor(props) {
                super(props);
                this.props = props;

                this.storeAuth = this.props.stores.storeAuth;
                this.storeUi = this.props.stores.storeUi;
                this.storeUsers = this.props.stores.storeUsers;
                this.storeForms = this.props.stores.storeForms;

                this.state = {
                    error_email: false,
                    error_email_empty: false,
                    formIsValid: false,
                    formControls: { 
                        firstname: {
                            type: "text",
                            value: '',
                            validationRules: {
                                isRequired: true
                            },
                            valid: false
                        },
                        middlename: {
                            type: "text",
                            value: '',
                            validationRules: {
                                isRequired: false
                            },
                            valid: true
                        },
                        lastname: {
                            type: "text",
                            value: '',
                            validationRules: {
                                isRequired: true
                            },
                            valid: false
                        },
                        email: {
                            type: "text",
                            value: '',
                            validationRules: {
                                isRequired: true,
                                isEmail: true
                            },
                            valid: false
                        }
                    }
                }
            }

            componentDidMount = async() => {
                let userId;
                
                if (this.storeAuth.user.isLoggedin) {
                    userId = this.storeAuth.user.accountId;
                } else {
                    (async() => await this.storeAuth.getGuestId())();
                    userId = this.storeAuth.user.guestId;
                }

                if (userId !== 0) {
                    const user = await this.storeUsers.getUser(userId);
                    this.setState({
                        user: user,
                    }, () => this.initForm())
                }
            } 

            componentDidUpdate = async(prevProps) => {
            }

            initForm = async() => {
                let name = '';
                let value = '';

                name = 'firstname';
                value =  this.state.user.firstname;
                if (value !== null) {
                    await this.initRow(name, value);
                }

                name = 'middlename';
                value =  this.state.user.middlename;
                if (value !== null) {
                    await this.initRow(name, value);
                }

                name = 'lastname';
                value =  this.state.user.lastname;
                if (value !== null) {
                    await this.initRow(name, value);
                }

                name = 'email';
                value =  this.state.user.email;
                if (value !== null) {
                    await this.initRow(name, value);
                }
            }

            initRow = async(name, value) => {
                let valid;
                valid = (value !== null && value !== '') ? true : false;

                const updatedControls = this.storeForms.validateRow(this.state.formControls, name, value, valid);

                this.setState({
                    formControls: updatedControls
                })
            }

            validateRow = (name, value, valid) => {        
                const updatedControls = this.storeForms.validateRow(this.state.formControls, name, value, valid);

                this.setState({
                    formControls: updatedControls
                }, () => this.validateForm()); 
            }

            validateForm = () => {
                const formIsValid = this.storeForms.validateForm(this.state.formControls);
                this.props.handleBtnProfile(formIsValid);
                console.log('Sbc valid form profile', formIsValid)

                this.setState({
                    formIsValid: formIsValid,
                    feedback: false
                }, () => this.saveAccount());
            }

            saveAccount = () => {
                const data = this.state.formControls;
                if (this.storeAuth.user.isLoggedin) {
                    this.storeUsers.saveUser('account', this.storeAuth.user.accountId, data);
                } else {
                    this.storeUsers.saveUser('guest', this.storeAuth.user.guestId, data);
                }
            }

            render() {
                return (
                    <form className="form">
                        {Object.keys(this.state.formControls).map((key, i) => (
                            <React.Fragment>
                                {key !== "country_select" &&                               
                                    <React.Fragment>
                                        {(this.state.formControls[key].type === "text" || this.state.formControls[key].type === "email" || this.state.formControls[key].type === "password") &&
                                            <RowText 
                                                type = {this.state.formControls[key].type}
                                                name = {key}
                                                value = {this.state.formControls[key].value}
                                                validationRules = {this.state.formControls[key].validationRules}
                                                validationMsg = {this.state.formControls[key].validationMsg}
                                                onValidate = {this.validateRow}
                                                disable = {this.state.formControls[key].disable}
                                            />
                                        }
                                    </React.Fragment>
                                } 

                            </React.Fragment>
                        ))}
                    </form>
                )
            }
        }
    )
)

export default withTranslation()(FormProfile);
